import { styled } from '@mui/system';
import { theme } from 'oems/theme';
import { Stack as StackMUI } from '@mui/material';

export const Stack = styled(StackMUI)`
    justify-content: center;
    height:30px;
    margin-top: 0px;
`;
